import { HttpClient, HttpContext, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiConfiguration } from '@/core/api/api-configuration';
import { BaseService } from '@/core/api/base-service';
import { environment } from '@env/environment';

import { ComissaoFrequenciaOpcaoResponse, FrequenciaComissaoResponse } from './frequencia-comissao.model';

@Injectable({ providedIn: 'root' })
export class FrequenciaComissaoService extends BaseService {
    readonly PATH = environment.basePath + '/comissoes/estatisticas/frequencia';

    constructor(config: ApiConfiguration, http: HttpClient) {
        super(config, http, environment.apis.apiSicom);
    }

    listarComissoes(ano: number, uf?: string | null, context?: HttpContext): Observable<ComissaoFrequenciaOpcaoResponse[]> {
        let params = new HttpParams().set('ano', String(ano));
        const ufNormalizada = String(uf ?? '')
            .trim()
            .toUpperCase();
        if (ufNormalizada && ufNormalizada !== 'BR') {
            params = params.set('uf', ufNormalizada);
        }
        return this.http.get<ComissaoFrequenciaOpcaoResponse[]>(`${this.PATH}/comissoes`, { params, context });
    }

    obterFrequencia(idEstrutura: number, ano: number, context?: HttpContext): Observable<FrequenciaComissaoResponse> {
        const params = new HttpParams().set('idEstrutura', String(idEstrutura)).set('ano', String(ano));
        return this.http.get<FrequenciaComissaoResponse>(this.PATH, { params, context });
    }
}
